import React from 'react'

const About = () => {
  return (
    <div>
    
      <div class="flex min-h-screen items-center justify-center bg-gradient-to-tr to-blue-700 from-indigo-900 p-10">
  <div class="w-max">
    <h1
      class="animate-typing overflow-hidden whitespace-nowrap border-r-4 border-r-white pr-5 text-5xl text-white font-bold">
      DEEZE INNOVATION
    </h1>
  </div>
</div>
    </div>
  )
}

export default About